import { Spinner } from '@chakra-ui/react';
import { Box } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';

interface ILoadingProps {
    disableBG?: boolean;
}
const Loading: React.FC<ILoadingProps> = ({ disableBG = false }) => {
    const { device, themeStyle } = useThemeContext();
    return (
        <Box
            sx={{
                display: 'flex',
                ...(!disableBG && { backgroundColor: theme[themeStyle].secondaryBg }),
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 99999,
                position: 'fixed',
                height: '100%',
                width: '100%',
            }}>
            <Spinner
                pos="absolute"
                color={theme[themeStyle].tag_white}
                size="xl"
                right={device.isMobile ? '40%' : '50%'}
                top={'20%'}
                h={10}
                w={10}
            />
        </Box>
    );
};

export { Loading };
